module.exports = __webpack_public_path__ + "assets/img/blue_bg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blue_bg.svg
// module id = 1920
// module chunks = 0